import { render, staticRenderFns } from "./addRule.vue?vue&type=template&id=4b4cc46f&scoped=true&"
import script from "./addRule.vue?vue&type=script&lang=js&"
export * from "./addRule.vue?vue&type=script&lang=js&"
import style0 from "./addRule.vue?vue&type=style&index=0&id=4b4cc46f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4cc46f",
  null
  
)

export default component.exports